import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import PageRoot from './PageRoot';
import PageAuto from './PageAuto';
import PageManual from './PageManual';

const router = createBrowserRouter([
  {
    path: "/",
    element: <PageRoot />,
  },
  {
    path: "/auto",
    element: <PageAuto />,
  },
  {
    path: "/manual",
    element: <PageManual />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
